import * as moment from "moment"
import { format as fnsFormat, isValid, parse as fnsParse } from "date-fns"
import "moment/locale/pt-br"
import times from "ramda/src/times"
import _size from "lodash/size"
import _split from "lodash/split"
import _get from "lodash/get"
import { enUS } from "date-fns/locale"
import "moment-timezone"

const calendar = {
  months: [
    "JAN",
    "FEV",
    "MAR",
    "ABR",
    "MAI",
    "JUN",
    "JUL",
    "AGO",
    "SET",
    "OUT",
    "NOV",
    "DEZ"
  ]
}

export function parse(date) {
  return moment(date, "DD/MM/YYYY")
}

export function formatDate(date) {
  if (isDateValid(date)) {
    return moment(date).format("DD/MM/YYYY")
  }
}

export function formatDateFns(date, originalFormat, wishFormat) {
  const parsedDate = fnsParse(date, originalFormat, new Date(), {
    locale: enUS
  })
  return fnsFormat(parsedDate, wishFormat)
}

export function isDateValid(date) {
  return moment(date).isValid()
}

export function toString(date) {
  return formatDate(date)
}

export function isDate(date) {
  return parse(date).isValid()
}

export function toDate(mixed) {
  return parse(mixed).toDate()
}

export function isExpiredDate(date) {
  const today = moment().startOf("day")
  return moment(date, "DD/MM/YYYY").isBefore(today)
}

export function formatDateFnsTimeZone(
  date,
  originalFormat,
  wishFormat,
  timezoneOffset = "-03:00"
) {
  const parsedDate = fnsParse(date, originalFormat, new Date(), {
    locale: enUS
  })

  if (!isValid(parsedDate)) {
    console.error("Data inválida: ", date)
    return null
  }

  const formattedDate = fnsFormat(parsedDate, wishFormat)
  return `${formattedDate}${timezoneOffset}`
}
function subtractMonth(date) {
  return new Date(date.setDate(0))
}

export function lastMonths(n, date = new Date()) {
  const months = []

  times(() => months.push(subtractMonth(date)), n)

  return months
}

export function addMonth(date) {
  return moment(date).add(1, "months").toDate()
}

export function nextMonths(n, date = new Date()) {
  const months = []

  times(() => months.push(addMonth(date)), n)

  return months
}

export function createMonthRange(before, after) {
  return [...lastMonths(before).reverse(), new Date(), ...nextMonths(after)]
}

export function isBetween(date, startDate, endDate) {
  return (
    (moment(date).isAfter(startDate) || moment(date).isSame(startDate)) &&
    (moment(date).isBefore(endDate) || moment(date).isSame(endDate))
  )
}

export const dateValidation = (date) => {
  let dueDate = ""
  if (moment(date).isValid()) {
    dueDate = formatDate(date)
    return isExpiredDate(dueDate)
  }
  return dueDate
}

export const getNameMonth = (dateAsString) => {
  const splitDate = _split(dateAsString, "/")

  if (!_size(splitDate)) return ""

  const monthInNumber = Number(_get(splitDate, "[1]", 0))

  return _get(calendar, `months[${monthInNumber - 1}]`, "")
}



// WEBPACK FOOTER //
// ./src/services/utils/date.js